module.exports = __webpack_public_path__ + "static/media/coca-cola.11d93882.png";